var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-mask',{staticClass:"form-control",attrs:{"mask":"C","tokens":_vm.hexTokens,"value":_vm.value},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }